export const search = (fieldInput, setSearch, data, byField) => {
  if (fieldInput.length === 0) {
    setSearch(data);
  }
  if (fieldInput.length > 0) {
    setSearch(data.filter((item) => item[byField].toLowerCase().slice(0, fieldInput.length) === fieldInput.toLowerCase()));
  }
};
